import number from './number.js'
import string from './string.js'
import store from './store.js'

export default {
  number, string, store
}
